module.exports = __webpack_public_path__ + "img/card1.13b10da3.png";